import { combineReducers } from 'redux'
import streamStatus from './streamStatus'
import dimensionStatus from './dimensionStatus'
import layoutReducer from './layoutStatus'
import parallaxStatus from './parallaxStatus'

const rootReducer = combineReducers({
  stream: streamStatus,
  dimensions: dimensionStatus,
  parallax: parallaxStatus,
  screenSize: layoutReducer,
})

export default rootReducer
